export default __webpack_public_path__ + "static/drago-f289b85f769ab011770f49e85d6d6cd9.png";